import { defineSlotRecipe } from "@pandacss/dev";

export const aromaBucket = defineSlotRecipe({
  className: "aroma-bucket",
  jsx: ["Bucket"],
  slots: [
    "wrap",
    "container",
    "sectionWrap",
    "section",
    "list",
    "emptySide",
    "bucketList",
    "bucketListItem",
    "art",
  ],
  base: {
    wrap: {
      width: "100%",
      display: "flex",
      alignItems: "flex-start",
      gap: "gap.2",
      sm: {
        gap: "gap.6",
      },
    },
    container: {
      paddingY: "padding.2",
      flexBasis: "100%",
      backgroundColor: "background.neutral.base.subtlest",
      borderRadius: "2xl",
      sm: {
        paddingY: "padding.4",
        flexBasis: "calc(50% - 12px)",
      },
    },
    sectionWrap: {
      paddingX: "padding.2",
      sm: {
        paddingX: "padding.4",
      },
    },
    section: {
      backgroundColor: "background.neutral.base.subtlest",
      borderWidth: "m",
      borderColor: "transparent",
      cursor: "pointer",
      transition: "all 0.3s ease-in-out",
      _hover: {
        backgroundColor: "background.neutral.base.subtlest-hover",
      },
      _focusVisible: {
        borderStyle: "solid",
        borderColor: "border.brand-bold",
        shadow: "effect.focus-ring.brand",
        outline: "none",
      },
      _active: {
        true: {
          borderStyle: "solid",
          borderColor: "border.brand-bold",
        },
      },
    },
    list: {
      position: "static",
      width: "100%",
      zIndex: 10,
      transform: "none",
      sm: {
        position: "absolute",
        left: "calc(100% + 24px)",
      },
    },
    emptySide: {
      display: "none",
      borderRadius: "2xl",
      backgroundColor: "background.neutral.base.subtlest",
      paddingX: "padding.6",
      paddingY: "padding.6",
      sm: {
        display: "block",
        flexBasis: "calc(50% - 12px)",
        paddingX: "padding.6",
        paddingY: "margin.16",
      },
    },
    bucketList: {
      width: "100%",
      borderRadius: "2xl",
      backgroundColor: "background.neutral.base.subtlest",
      padding: "padding.4",
      paddingLeft: "margin.16",
      sm: {
        paddingLeft: "padding.4",
      },

      "& a": {
        textDecoration: "none",
        color: "content.neutral.base.subtle",
      },
    },
    bucketListItem: {
      justifyContent: "space-between",
      height: "xl",
      paddingX: "padding.3",
      gap: "gap.2",
      borderRadius: "l",
      zIndex: "1",
      cursor: "pointer",
      _hover: {
        bgColor: "background.neutral.base.subtlest-hover",
        zIndex: "2",
      },
      _active: {
        bgColor: "background.neutral.base.subtlest-active",
        zIndex: "3",
      },
    },
    art: {
      display: "none",
      md: {
        display: "block",
        padding: "padding.6",
      },
    },
  },
  variants: {
    size: {
      large: {
        section: {
          padding: "padding.4",
          sm: {
            padding: "padding.6",
          },
        },
      },
      small: {
        section: {
          padding: "padding.4",
        },
      },
    },
    popupPosition: {
      top: {
        list: {
          top: "-16px",
          bottom: "unset",
        },
      },
      bottom: {
        list: {
          top: "unset",
          bottom: "-16px",
        },
      },
      center: {
        list: {
          sm: {
            top: "50%",
            bottom: "unset",
            transform: "translateY(-50%)",
          },
        },
      },
    },
  },
  defaultVariants: {
    size: "large",
  },
});
